import { PayfortTransInfoModel } from './../../../Models/ProposalModel';
import { restURL } from './../../../Models/restURL';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { TravelBindMdl, TravelstatusMdl } from './../../../Models/TravelBindMdl';
import { Component } from '@angular/core';
import { TravelProposalMdl } from '../../../Models/TravelProposalMdl';
import { TravelPolicyModel } from '../../../Models/TravelPolicyModel';
import { LanguageService } from '../../../Services/languageService';
import { userService } from '../../../Services/userService';
import { motorProposalService } from '../../../Services/motorProposalService';
import { mdlPayloadResponse } from '../../../Models/mdlPayloadResponse';
import { mdlPayloadRequest } from '../../../Models/mdlPayloadRequest';
import Swal from 'sweetalert2';


@Component({
    selector: 'TravelReviewConfirm',
    templateUrl: './TravelReviewConfirm.html',
    styleUrls: ['./TravelReviewConfirm.css']
})
export class TravelReviewConfirm {
    public httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json' }) };
    public travelBindObj: TravelBindMdl = new TravelBindMdl();
    public prObj: TravelProposalMdl = new TravelProposalMdl();
    public transObj: PayfortTransInfoModel = new PayfortTransInfoModel();
    public travelPolicyObj: TravelPolicyModel = new TravelPolicyModel();
    public Travelstatusobj: TravelstatusMdl = new TravelstatusMdl();
    public isShowLoading: boolean = false;
    public LngSubscription: Subscription;
    public Lng: string;
    public isSubmitted: boolean;
    public ZoneName: string;
    public ZoneNameAr: string;
    public PlanName: string;
    public PlanNameAr: string;
    public InsuranceType: string;
    public InsuranceTypeAr: string;
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();


    constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private url: restURL, private lngService: LanguageService, private userinfo: userService) {

        this.isSubmitted = false;

        // this.prObj.IOccupation="";

        this.LngSubscription = this.lngService.grtLng().subscribe(lng => { this.Lng = lng });
        if (sessionStorage.getItem("Language") != null) {
            this.Lng = sessionStorage.getItem("Language");
        }
        else {
            this.Lng = "en";
        }



        this.getBindInfo();
    }
    goNext() {

        this.saveProposal();
    }

    ValidateIBAN() {

        this.isShowLoading = true;
        this.prObj.IBAN = this.prObj.IBAN1 + this.prObj.IBAN2 + this.prObj.IBAN3 + this.prObj.IBAN4 + this.prObj.IBAN5 + this.prObj.IBAN6;
        this.prObj.IBAN = "SA" + this.prObj.IBAN;
        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.prObj));

        //this.http.post<TravelstatusMdl>(this.url.baseURL + "/travelBind/ValidateTravelIBAN", this.prObj, this.userinfo.getHttpOptions())
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/travelBind/ValidateTravelIBAN", this.objPayloadRequest, this.userinfo.getHttpOptions())
            .toPromise()
            .then((result) => {
                //this.Travelstatusobj = result;
                //New Line Start
                this.objPayloadResponse = result;
                this.Travelstatusobj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                //NewLine End


                this.isShowLoading = false;

                if (this.Travelstatusobj.StatusCode == "F") {
                    this.Lng == "en" ? Swal(this.Travelstatusobj.StatusDesc) : Swal(this.Travelstatusobj.StatusDescAr);

                }
                else {
                    this.saveProposal();
                }
            }, (error) => {
                this.userinfo.checkTokenStatus(error);
                this.isShowLoading = false;
                this.Lng == "en" ? Swal("Please try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");

            });


    }




    saveProposal() {

        this.isShowLoading = true;
        let regNo: string = sessionStorage.getItem("RegNo");
        this.prObj.RegNo = regNo;


        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.prObj));

        //this.http.post<PayfortTransInfoModel>(this.url.baseURL + "/travelBind/saveTravelProposal", this.prObj, this.userinfo.getHttpOptions())
        this.http.post<mdlPayloadResponse>(this.url.baseURL + "/travelBind/saveTravelProposal", this.objPayloadRequest, this.userinfo.getHttpOptions())
            .toPromise()
            .then((result) => {
                this.isShowLoading = false;
                //this.transObj = result;
                // //New Line Start
                // this.objPayloadResponse = result;
                // this.transObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                // //NewLine End

                //New Line Start
                this.objPayloadResponse = result;

                let objResObj: PayfortTransInfoModel = new PayfortTransInfoModel();
                objResObj = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
                if (objResObj.RegNo != this.prObj.RegNo) {
                    Swal("Invalid Response", "Technical Error: Request Object Does Not Match With Response Object", "error")
                    this.router.navigate(['BeforeLogin/NewReg']);
                    return;
                }
                this.transObj = objResObj;
                //NewLine End




                if (this.transObj.st.StatusCode === "S") {
                    this.Lng == "en" ? Swal(this.transObj.st.StatusDesc) : Swal(this.transObj.st.StatusDescAr);
                    sessionStorage.setItem("NavFrom", "PR");
                    //sessionStorage.setItem("transObj", JSON.stringify(this.transObj));
                    sessionStorage.setItem("transObj", this.EncriptService.EncriptObject(JSON.stringify(this.transObj)));
                    sessionStorage.setItem("CurrentRoute", "PayfortPayment");
                    this.router.navigate(['/NewDashboard/PayfortPayment']);

                }
                else {
                    this.Lng == "en" ? Swal(this.transObj.st.StatusDesc) : Swal(this.transObj.st.StatusDescAr);
                    this.router.navigate(['/NewDashboard/Welcome']);

                }
            }, (error) => {
                this.userinfo.checkTokenStatus(error);
                this.isShowLoading = false;
                this.Lng == "en" ? Swal("Please try again later") : Swal("الرجاء معاودة المحاولة في وقت لاحق");
                this.router.navigate(['/NewDashboard/Welcome']);

            });




    }

    goPrevious() {
        //sessionStorage.setItem("TravelBindObj", JSON.stringify(this.travelBindObj));
        sessionStorage.setItem("TravelBindObj", this.EncriptService.EncriptObject(JSON.stringify(this.travelBindObj)));


        sessionStorage.setItem("CurrentRoute", "TravelBasicInfo");
        this.router.navigate(['NewDashboard/TravelProposalForm/TravelBasicInfo']);
    }
    getBindInfo() {


        if (sessionStorage.getItem("TravelBindObj") != null) {

            //this.travelBindObj = JSON.parse(sessionStorage.getItem("TravelBindObj"));
            this.travelBindObj = JSON.parse(this.EncriptService.DecriptObject(sessionStorage.getItem("TravelBindObj")));
            //this.travelPolicyObj= JSON.parse(sessionStorage.getItem("newPolicyObj"));
            this.prObj = this.travelBindObj.propoalObj;
            this.ZoneName = this.travelBindObj.zoneList.filter(z => z.ZoneCode == this.prObj.ZoneCode)[0].ZoneDescEn;
            this.ZoneNameAr = this.travelBindObj.zoneList.filter(z => z.ZoneCode == this.prObj.ZoneCode)[0].ZoneDescAr;
            this.PlanName = this.travelBindObj.planList.filter(p => p.PlanCode.toString() == this.prObj.PlanCode)[0].PlanDescEn;
            this.PlanNameAr = this.travelBindObj.planList.filter(p => p.PlanCode.toString() == this.prObj.PlanCode)[0].PlanDescAr;
            this.InsuranceType = this.travelBindObj.insTypeList.filter(t => t.InsuredTypeCode.toString() == this.prObj.InsuranceType)[0].InsuredTypeDescEn;
            this.InsuranceTypeAr = this.travelBindObj.insTypeList.filter(t => t.InsuredTypeCode.toString() == this.prObj.InsuranceType)[0].InsuredTypeDescAr;

        }
        else {
            sessionStorage.setItem("CurrentRoute", "TravelPolicy");
            this.router.navigate(['NewDashboard/TravelPolicy']);
        }

    }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/TravelPortal/TravelReviewConfirm/TravelReviewConfirm.ts